export default __webpack_public_path__ + "static/media/step1-lovrican.661f860b.svg";